var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107.8 151.5",
    style: {
      enableBackground: "new 0 0 107.8 151.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.5,42.7c0,3.6-1.7,6.7-4.3,8.7c-1.9,1.5-4.2,2.3-6.7,2.3c-2.5,0-4.7-0.8-6.5-2.2c-2.7-2-4.5-5.3-4.5-8.9 c0-6.1,4.9-11,11-11S64.5,36.6,64.5,42.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,42.7c0-6.1,4.9-11,11-11s11,5,11,11c0,3.6-1.7,6.7-4.3,8.7c-1.9,1.5-4.2,2.3-6.7,2.3 c-2.5,0-4.7-0.8-6.5-2.2C44.2,49.6,42.4,46.4,42.4,42.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.2-0.1c-8.6,0.8-17.1,3.6-24.7,8.3C0.8,22.4-6.4,50.2,6,72.7l41.3,74.5c2.9,5.1,10.3,5.1,13.1,0l41.3-74.5 C121.3,37.5,91-4.2,48.2-0.1z M79.7,76.5C78.9,66.2,72.7,57.6,64,53.7c-2.6,2.9-6.4,4.7-10.5,4.7c-4,0-7.7-1.7-10.3-4.5 c-8.5,4-14.5,12.6-15.3,22.7c-5.6-6.2-9.1-14.5-9.1-23.5c0-19.3,15.6-34.9,34.9-34.9c19.3,0,34.9,15.6,34.9,34.9 C88.7,62.2,85.3,70.3,79.7,76.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.5,42.7c0,3.6-1.7,6.7-4.3,8.7c-1.9,1.5-4.2,2.3-6.7,2.3c-2.5,0-4.7-0.8-6.5-2.2c-2.7-2-4.5-5.3-4.5-8.9 c0-6.1,4.9-11,11-11S64.5,36.6,64.5,42.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.2ad30f7e0f850a4b3d3907f7b8d9437b.svg";
export { ForwardRef as ReactComponent };